module.exports = __webpack_public_path__ + "img/cabbage-red-glasses.930fa0a2.png";